module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921085651_T.aa83029b.jpg";